import { Button } from '@/components/ui/button'
import { setActiveTab } from '@common-reducers/CampaignReducer'
import { campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks"
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { Pencil } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';
import { formatInLanguage } from '@common/config/moment-locales';
import { useClockPreference } from '@common/hooks/use-clock-preference';
import { formatClockTime } from '@common/config/time-format';

type Props = {
    campaignId?: string;
}

export default function CampaignSummaryTimingDialog({ campaignId }: Props) {
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation(namespace);
    const clockPreference = useClockPreference();
    let campaign
    const _campaign = useAppSelector((state) => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, { _id: campaignId }))
    const newCampaign = useAppSelector((state) => state.CampaignReducer.newCampaign)

    if (campaignId) campaign = _campaign
    else campaign = newCampaign

    // const patternString = !!campaign?.schedule?.rruleset ? RRule.fromString(campaign?.schedule?.rruleset).toText() : 'No pattern specified'
    // Was `dayjs(...).format('MMMM D, YYYY')` — the US month-day-year order, in
    // every language, so a Hebrew reader got "יולי 9, 2026". `formatInLanguage`
    // is the app's own formatter and takes the render's language explicitly:
    // 'LL' is the locale's OWN long date ("9 ביולי 2026"), 'LT' its own clock.
    // The language is passed in rather than read off moment's global locale,
    // which can still be English on the first render after a language change.
    const dueDate = campaign?.schedule?.dueDate
    const startingAtString = (!campaignId && campaign?.schedule?.isNow)
        ? t('dateTime.now')
        : t('campaignSummary.startingAt', {
            date: formatInLanguage(dueDate, i18n.language, 'LL'),
            time: formatClockTime(dueDate, i18n.language, clockPreference),
        })

    return (
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 w-full">
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold text-sky-600 dark:text-sky-400 flex items-center gap-2">
                    {t('campaignSummary.dueDate')}: <span className="text-slate-900 dark:text-slate-50 font-normal">{startingAtString}</span>
                </h2>
                {!campaignId && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => dispatch(setActiveTab('timeAndDate'))}
                        className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors h-8 w-8"
                    >
                        <Pencil className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                    </Button>
                )}
            </div>
        </div>
    )
}